import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

export const archiveTaskTemplate = async (uuid: string) => {
  const response = await CustomAxios.post(`task_templates/${uuid}/archive`);
  return response.data;
};

interface UseArchiveTaskTemplateProps {
  uuid: string;
  onSuccessCallback: () => void;
}

export function useArchiveTaskTemplate({ uuid, onSuccessCallback }: UseArchiveTaskTemplateProps) {
  return useMutation({
    mutationFn: () => archiveTaskTemplate(uuid),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.allTaskTemplates, uuid] });
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        alert('Failed to archive the task template. Please try again and contact support if the problem persists.');
      } else {
        console.error('Unexpected error archiving task template:', err);
      }
    },
  });
}
